import type { ContentEntry, ContentResponse } from './types.js';

export interface SdkState {
  response: ContentResponse | null;
  /** Cached validator so a refresh can be answered with a 304. */
  etag: string | null;
  applied: Set<string>;
  missing: Set<string>;
}

export function createState(): SdkState {
  return { response: null, etag: null, applied: new Set(), missing: new Set() };
}

/** Page entries shadow globals, so a page can override a site-wide value. */
export function entryFor(state: SdkState, key: string): ContentEntry | undefined {
  const response = state.response;
  if (!response) return undefined;
  return response.entries?.[key] ?? response.globals?.[key];
}
